module.exports = __webpack_public_path__ + "img/i1@2x.625666e8.png";